/* TODO: Bu Component ListComponent'ten kopyalandı. Birçok gereksiz metod, içerik barındırıyor. Temizlenecek. */

import {
    arrayOf,
    bool,
    func,
    number,
    object,
    oneOfType,
    shape,
    string,
  } from "prop-types";
  import React, { Component } from "react";
  import { formatDate, formatNullData } from "../../utils";
  // import ActionButtons from "../action-buttons";
  import Table from "../table";
  import DefaultActionButtonGenerator, {
    ACTION_BUTTON_TYPES as ABT,
  } from "../action-buttons/ActionButtonGenerator";
  import ActionButtons from "../action-buttons";
  import request from "../../services/request";
  import FileSaver from "file-saver";
  import { withRouter } from "react-router-dom";
  import Filters from "./Filters";
  import { withTranslation } from "react-i18next";
  import ConfirmModal from "../modals/confirm-modal";
  
  class ListStatus extends Component {
    constructor(props) {
      super(props);
  
      this.getData = this.getData.bind(this);
      this.onPageChange = this.onPageChange.bind(this);
      this.onEditClicked = this.onEditClicked.bind(this);
      this.onDeleteClicked = this.onDeleteClicked.bind(this);
      this.onGoToPageClicked = this.onGoToPageClicked.bind(this);
      this.onChangeStatusClicked = this.onChangeStatusClicked.bind(this);
      this.onDownloadClicked = this.onDownloadClicked.bind(this);
      this.onDownloadExcelClicked = this.onDownloadExcelClicked.bind(this);
      this.onPreviewClicked = this.onPreviewClicked.bind(this);
      this.onRowSelect = this.onRowSelect.bind(this);
      this.onSingleRowSelect = this.onSingleRowSelect.bind(this);
      this.onAllRowsSelect = this.onAllRowsSelect.bind(this);
      this.onSortChange = this.onSortChange.bind(this);
  
      const eventsObjects = {
        [ABT.EDIT.name]: this.onEditClicked,
        [ABT.ARCHIVE.name]: this.onEditClicked,
        [ABT.DELETE.name]: this.onDeleteClicked,
        [ABT.ACTIVE.name]: this.onChangeStatusClicked,
        [ABT.PASSIVE.name]: this.onChangeStatusClicked,
        [ABT.DOWNLOAD.name]: this.onDownloadClicked,
        [ABT.EXCEL_EXPORT.name]: this.onDownloadExcelClicked,
        [ABT.PREVIEW.name]: this.onPreviewClicked,
        [ABT.GOTOPAGE.name]: this.onGoToPageClicked,
        [ABT.GOTOPAGETWO.name]: this.onGoToPageClicked,
      };
  
      this.state = {
        language: props.i18n && props.i18n.language,
        pageIndex: 1,
        pageSize: props.defaultPageSize ? props.defaultPageSize : 10,
        totalSize: 0,
        data: [],
        columns: props.columns.map((column) => {
          column.formatter = column.formatter ? column.formatter : formatNullData;
          column.onSort = this.onSortChange;
          column.attrs = column.attrs
            ? column.attrs
            : function callback(cell) {
                return { title: cell };
              };
          column.headerAttrs = function callback(column) {
            return { title: column.text };
          };
          return column;
        }),
        actionButtons: props.actionButtonsObject.generator(
          props.actionButtonsObject,
          eventsObjects
        ),
        selectedRows: [],
        onSortChangeFunc: this.onSortChange,
        newComment: "",
        showConfirmModal: false,
        selectedCommentId: null,
      };
    }
  
    componentDidMount() {
      this.getData();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
      let x = ABT;
      if (prevProps.refreshList !== this.props.refreshList) {
        this.getData({ pageIndex: 1 });
        this.onRowSelect(this.state.selectedRows[0],false);
        if (document.getElementsByClassName("page-link") && document.getElementsByClassName("page-link").length > 0) {
          document.getElementsByClassName("page-link")[0].click();
        }
      }
  
      if (this.state.language !== this.props.i18n.language) {
        this.getData();
        this.setState({
          language: this.props.i18n.language,
        });
      }
  
      if (prevProps.columns != this.props.columns) {
        this.setState({
          columns: this.props.columns.map((column) => {
            column.formatter = column.formatter
              ? column.formatter
              : formatNullData;
            column.onSort = this.onSortChange;
            column.attrs = column.attrs
              ? column.attrs
              : function callback(cell) {
                  return { title: cell };
                };
            column.headerAttrs = function callback(column) {
              return { title: column.text };
            };
            return column;
          }),
        });
      }
    }
  
    componentWillUnmount() {
      this.setState({
        data: [],
        totalSize: 0,
        selectedRows: null,
      });
    }
  
    getData(params = {}) {
      const { customBody } = this.props;
      const {
        pageIndex = this.state.pageIndex,
        pageSize = this.state.pageSize,
        sortProps = this.state.sortProps,
      } = params;
  
      let queryBody = {
        sortOrder: "DESC",
        pageIndex: pageIndex - 1,
        pageSize: pageSize,
        filters: [],
      };
  
      if (sortProps) {
        queryBody.sortOrder = sortProps.order.toUpperCase();
        queryBody.sortColumn = sortProps.field;
      } else if (customBody.sortColumn) {
        queryBody.sortOrder = customBody.sortOrder;
        queryBody.sortColumn = customBody.sortColumn;
      }
  
      if (customBody.filters) {
        queryBody.filters = queryBody.filters.concat(customBody.filters);
      }
  
      if (customBody.id) {
        queryBody.id = customBody.id;
      }
  
      if (customBody.userId) {
        queryBody.userId = customBody.userId;
      }
  
      if (customBody.talepTurId) {
        queryBody.talepTurId = customBody.talepTurId;
      }
  
      const { endpoint } = this.props;
  
      request({
        url: endpoint,
        method: "POST",
        data: {
          body: queryBody,
        },
      }).then((res) => {
        if (res.responseStatus === "SUCCESS") {
          this.setTableData(res);
        }
      });
    }
  
    onSortChange(field, order) {
      const param = {
        sortProps: {
          field: field,
          order: order,
        },
      };
  
      this.setState(param);
      this.getData(param);
    }
  
    setTableData(response) {
      const { mapDataBeforeList, mapNativeDataBeforeList } = this.props;
      let newResponse = response.body
        ? response.body.tableData
          ? response.body.tableData
          : response.body
        : [];
  
      if (mapNativeDataBeforeList) {
        newResponse = mapNativeDataBeforeList(newResponse);
      }
  
      if (mapDataBeforeList) {
        newResponse = newResponse.map(mapDataBeforeList);
      }
  
      this.setState({
        data: newResponse,
        totalSize: response.body ? response.body.totalElements : 0,
      });
    }
  
    onPageChange(pageIndex, pageSize) {
      if (
        pageIndex !== this.state.pageIndex ||
        pageSize !== this.state.pageSize
      ) {
        this.getData({
          pageIndex: pageIndex,
          pageSize: pageSize,
        });
  
        this.setState({ pageIndex, pageSize });
      }
    }
  
    handleToggleColumn(columns) {
      this.setState({
        columns,
      });
    }
  
    onEditClicked(buttonObj) {
      const { selectedRows } = this.state;
      const { history } = this.props;
  
      buttonObj.params(selectedRows[0]);
    }
  
    onDeleteClicked(buttonObj) {
      const { selectedRows } = this.state;
      const { keyField } = this.props;
  
      let selectedRow = selectedRows[0];
  
      request({
        url: buttonObj.requestTo,
        method: "POST",
        data: {
          body: {
            [keyField]: selectedRow[keyField],
          },
        },
      }).then((res) => {
        if (res.responseStatus === "SUCCESS") {
          this.getData();
          this.setState({
            selectedRows: [],
          });
        }
      });
    }
  
    onGoToPageClicked(buttonObj) {
      const { selectedRows } = this.state;
      const { history } = this.props;
      history.push({
        pathname: buttonObj.pushWithRow,
        state: {
          row: selectedRows[0],
        },
      });
    }
  
    onChangeStatusClicked(buttonObj) {
      const { selectedRows } = this.state;
      const { keyField } = this.props;
  
      let selectedRow = selectedRows[0];
  
      request({
        url: buttonObj.requestTo,
        method: "POST",
        data: {
          body: {
            [keyField]: selectedRow[keyField],
            stId: buttonObj.stId,
          },
        },
      }).then((res) => {
        if (res.responseStatus === "SUCCESS") {
          this.getData();
        }
      });
    }
  
    onDownloadClicked(buttonObj) {
      const { selectedRows } = this.state;
      const { keyField } = this.props;
  
      let selectedRow = selectedRows[0];
  
      request({
        url: buttonObj.requestTo,
        method: "POST",
        data: {
          body: {
            [keyField]: selectedRow[keyField],
          },
        },
      }).then((res) => {
        var buffer = new Buffer(res.data, "base64");
        var blob = new Blob([buffer], { type: res.headers["content-type"] });
        FileSaver.saveAs(blob, selectedRow.fileName);
      });
    }
  
    onDownloadExcelClicked(buttonObj) {
      const { selectedRows } = this.state;
      const { customBody } = this.props;
  
      if (selectedRows) {
        var selectedRow = selectedRows[0];
      }
  
      request({
        url: buttonObj.params.requestTo,
        method: "POST",
        data: {
          body: {
            sortOrder: "DESC",
            pageIndex: 0,
            pageSize: 10000,
            filters: customBody.filters || [],
            talepTurId: buttonObj.params.talepTurId,
          },
        },
      }).then((res) => {
        var buffer = new Buffer(res.data, "base64");
        var blob = new Blob([buffer], { type: res.headers["content-type"] });
        FileSaver.saveAs(blob, "Excel.xls");
      });
    }
  
    onPreviewClicked(buttonObj) {
      const { selectedRows } = this.state;
      const { keyField } = this.props;
  
      let selectedRow = selectedRows[0];
  
      request({
        url: buttonObj.requestTo,
        method: "POST",
        data: {
          body: {
            [keyField]: selectedRow[keyField],
          },
        },
      }).then((res) => {
        var buffer = new Buffer(res.data, "base64");
        var blob = new Blob([buffer], { type: res.headers["content-type"] });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
  
    onRowSelect(row, isSelected) {
      const { selectedRows } = this.state;
      const { keyField, setSelectedRow } = this.props;
  
      let newArray = [];
  
      if (isSelected) {
        if (selectedRows.every((x) => x[keyField] !== row[keyField])) {
          newArray = JSON.parse(JSON.stringify(selectedRows));
          newArray.push(row);
        }
      } else {
        if (selectedRows.some((x) => x[keyField] === row[keyField])) {
          newArray = selectedRows.filter((x) => x[keyField] !== row[keyField]);
        }
      }
  
      if (setSelectedRow) {
        setSelectedRow(newArray);
      }
  
      this.setState({ selectedRows: newArray });
    }
  
    onSingleRowSelect(row, isSelected) {
      const { selectedRows } = this.state;
      const { keyField } = this.props;
      let newArray = [];
  
      if (isSelected) {
        newArray.push(row);
        this.setState({ selectedRows: [] });
      } else {
        if (selectedRows.some((x) => x[keyField] === row[keyField])) {
          newArray = selectedRows.filter((x) => x[keyField] !== row[keyField]);
        }
      }
      this.setState({ selectedRows: newArray });
    }
  
    onAllRowsSelect(rows, isSelected) {
      let newArray = [];
  
      if (isSelected) {
        newArray = JSON.parse(JSON.stringify(this.state.data));
      }
      const { setSelectedRow } = this.props;
      if (setSelectedRow) {
        setSelectedRow(newArray);
      }
      this.setState({ selectedRows: newArray });
    }

    editButtonHandler = (commentId) => {
      let tempColumns = this.state.data.map((item) => {
        if (item.id === commentId) {
          return {
            ...item,
            isEdit: true,
          };
        } else {
          return {
            ...item,
            isEdit: false,
          }
        }
      });
      this.setState({ data: tempColumns });
    };

    onDeleteButtonClicked = (commentId) => {
      this.setState({ selectedCommentId: commentId });
      this.setState({ showConfirmModal: true });
    };
    
    deleteComment = () => {
      request({
        url: "/yonlendirilecek-talep/son-durum-delete",
        method: "POST",
        data: {
          body: {
              id: this.state.selectedCommentId,
          },
        },
      }).then((res) => {
        if (res.responseStatus === "SUCCESS") {
          this.setState({ showConfirmModal: false });
          this.getData();
        }
        else {
          this.setState({ showConfirmModal: false });
        }
      });
    };

    onSaveButtonClicked = (commentId) => {
      let lastComment = this.state.newComment;
      request({
        url: "/yonlendirilecek-talep/son-durum-update",
        method: "POST",
        data: {
          body: {
              id: commentId,
              mesaj: lastComment,
          },
        },
      }).then((res) => {
        if (res.responseStatus === "SUCCESS") {
          this.getData();
        }
      });
    }; 
  
    render() {
      const {
        data,
        columns,
        pageIndex,
        pageSize,
        totalSize,
        actionButtons,
        selectedRows,
      } = this.state;
      const {
        keyField,
        development,
        basicData,
        isMultiSelect,
        expandable,
        expandComponent,
        hideSelection,
        expandItem,
        visiblePagination,
        visibleRowSelect,
        specificKeyField,
        filters,
        totalDay,
        hideBorder,
        t,
      } = this.props;
  
      return (
        <>
          <div className={hideBorder ? "" : "border rounded mt-3 p-3"}>
            {actionButtons && (
              <>
                <ActionButtons
                  ref="ActionButtons"
                  buttons={actionButtons}
                  selectedRows={selectedRows}
                  keyField={keyField}
                  refreshList={this.getData}
                />
              </>
            )}
            {totalDay && (
              <span className="float-right text-black">
                Toplam Süre: {totalDay}
              </span>
            )}
            { data.map((elem) => {
                return (
                <div className="mb-3 p-3 border border-primary rounded">
                    <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0" }}>
                      <small>
                        <span className="text-primary font-weight-bold">{elem?.userDto?.fullName}&nbsp;</span>
                        <span className="text-muted font-italic">({formatDate(elem.createdDate)} - {t('tabs.eklendi')})</span>
                        { elem.lastUpdatedDate && <span className="text-muted font-italic">, ({formatDate(elem.lastUpdatedDate)} - {t('tabs.guncellendi')})</span> }
                      </small>
                      <div>
                        { !elem.isEdit &&
                          <>
                            <button className="btn btn-xs btn-primary mr-2" onClick={() => this.onDeleteButtonClicked(elem.id)}><i className="fa fa-trash"></i></button> 
                            <button className="btn btn-xs btn-primary" onClick={() => this.editButtonHandler(elem.id)}><i className="fa fa-edit"></i></button>
                          </> 
                        }
                      </div>
                    </label>
                    { elem.isEdit ?
                    <div className="row">
                      <div className="col-md-12">
                        <textarea className="form-control mt-2" rows="2" defaultValue={elem.mesaj} ref={this.textAreaRef} onChange={(e) => this.setState({ newComment: e.target.value})}></textarea>
                        <button className="btn btn-xs btn-primary mt-2 float-right" onClick={() => this.onSaveButtonClicked(elem.id)} ><i className="fa fa-save"></i></button>
                      </div>
                    </div> : <p className="mb-0">{elem.mesaj}</p> }
                </div>)
              })
            }
          </div>
          <ConfirmModal 
            show={this.state.showConfirmModal}
            setShowModal={(showConfirmModal) => this.setState({ showConfirmModal })}
            onYesButtonClicked={() => this.deleteComment()}
            closeModal={() => this.setState({ showConfirmModal: false })}
            modalBodyMessage={t("modal.areYouSure")}
            modalTitle={t("modal.warningTitle")}
          />
        </>
      );
    }
  }
  
  export default withRouter(withTranslation()(ListStatus));
  
  ListStatus.propTypes = {
    actionButtonsObject: shape({
      actions: arrayOf(object),
      generator: func,
    }),
    keyField: string.isRequired,
    entityName: string.isRequired,
    columns: arrayOf(object).isRequired,
    endpoint: string.isRequired,
    mapDataBeforeList: func,
    mapNativeDataBeforeList: func,
    reportSource: string,
    exportExcelSource: string,
    httpActions: object,
    history: object,
    isMultiSelect: bool,
    permBase: object,
    user: object,
    hideSelection: bool,
    expandItem: string,
    customBody: shape({
      sortOrder: string,
      sortColumn: string,
      filters: arrayOf(
        shape({
          fieldName: string,
          value: oneOfType([string, bool, number]),
          oper: string,
        })
      ),
    }),
  };
  
  ListStatus.defaultProps = {
    actionButtonsObject: {
      actions: [],
      generator: DefaultActionButtonGenerator,
    },
    keyField: "id",
    customBody: {},
    isMultiSelect: false,
    entityName: "",
    endpoint: "",
  };
  